/**
 * The three breakpoints a builder block can be hidden on (styles.hideMobile/hideTablet/hideDesktop).
 * The ranges mirror the `.block-hide-*` rules in app/storefront.css and app/globals.css — change
 * them together.
 */
export type Breakpoint = 'mobile' | 'tablet' | 'desktop';

export const ALL_BREAKPOINTS: readonly Breakpoint[] = ['mobile', 'tablet', 'desktop'];

const MEDIA: Record<Breakpoint, string> = {
  mobile: '(max-width: 639.98px)',
  tablet: '(min-width: 640px) and (max-width: 1023.98px)',
  desktop: '(min-width: 1024px)',
};

export function isHiddenOn(styles: any, breakpoint: Breakpoint): boolean {
  if (!styles) return false;
  if (breakpoint === 'mobile') return Boolean(styles.hideMobile);
  if (breakpoint === 'tablet') return Boolean(styles.hideTablet);
  return Boolean(styles.hideDesktop);
}

/** Media query matching exactly the given breakpoints; undefined when that's all of them. */
export function breakpointsMedia(breakpoints: readonly Breakpoint[]): string | undefined {
  const set = new Set(breakpoints);
  if (set.size === 0 || set.size === ALL_BREAKPOINTS.length) return undefined;
  if (set.has('mobile') && set.has('tablet')) return '(max-width: 1023.98px)';
  if (set.has('tablet') && set.has('desktop')) return '(min-width: 640px)';
  return ALL_BREAKPOINTS.filter((bp) => set.has(bp)).map((bp) => MEDIA[bp]).join(', ');
}
